module.exports = __webpack_public_path__ + "static/media/kalt.10ec4ac9.mp3";